export const ON_SELECT_PERIOD = 'ON_SELECT_PERIOD';
export const ON_RESTORE_PERIOD = 'ON_RESTORE_PERIOD';
export const ON_AREA_POINT_HOVER = 'ON_AREA_POINT_HOVER';
export const ON_SCATTER_POINT_HOVER = 'ON_SCATTER_POINT_HOVER';
export const ON_SCATTER_POINT_CLICK = 'ON_SCATTER_POINT_CLICK';
export const ON_REMOVE_SELECTED_POINTS_FILTER =
  'ON_REMOVE_SELECTED_POINTS_FILTER';
export const SET_SCATTER_ENTITIES_IDS = 'SET_SCATTER_ENTITIES_IDS';
export const SET_METRIC_RAW_EVENTS = 'SET_METRIC_RAW_EVENTS';

export const ON_SELECT_MULTIPLE_POINTS = 'SET_SELECTED_POINTS';
export const SET_IS_LOADING_SCATTER = 'SET_IS_LOADING_SCATTER';
export const SET_BRANCHES_CYCLE_TIME_STAGES = 'SET_BRANCHES_CYCLE_TIME_STAGES';
export const onSelectPeriod = period => ({
  type: ON_SELECT_PERIOD,
  payload: period
});

export const onRestorePeriod = () => ({
  type: ON_RESTORE_PERIOD
});

export const onAreaPointHover = point => ({
  type: ON_AREA_POINT_HOVER,
  payload: point
});

export const onScatterPointClick = point => ({
  type: ON_SCATTER_POINT_CLICK,
  payload: point
});

export const onScatterPointHover = point => ({
  type: ON_SCATTER_POINT_HOVER,
  payload: point
});

export const onSelectMultiplePoints = points => ({
  type: ON_SELECT_MULTIPLE_POINTS,
  payload: points
});

export const onRemoveSelectedPointsFilter = () => ({
  type: ON_REMOVE_SELECTED_POINTS_FILTER
});

export const setScatterEntitiesIds = entitiesIds => ({
  type: SET_SCATTER_ENTITIES_IDS,
  payload: entitiesIds
});

export const setMetricRawEvents = entities => ({
  type: SET_METRIC_RAW_EVENTS,
  payload: entities
});

export const setIsLoadingScatter = isLoading => ({
  type: SET_IS_LOADING_SCATTER,
  payload: isLoading
});

export const setBranchesCycleTimeStages = branchesCycleTimeStages => ({
  type: SET_BRANCHES_CYCLE_TIME_STAGES,
  payload: branchesCycleTimeStages
});
